import { Card, CardContent, StripeForm } from '../../../../components'
import {
  Box,
  Divider,
  Stack,
  Typography,
  CircularProgress,
} from '@elphasecure/elpha-design-system'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'

const STRIPE_API = `${
  (window as any)?._env_?.REACT_APP_STRIPE_API !== undefined
    ? (window as any)?._env_?.REACT_APP_STRIPE_API
    : process.env.REACT_APP_STRIPE_API
}`

const stripePromise = loadStripe(STRIPE_API)

const Invoice = ({
  handleNext,
  policyData,
  isLoading,
  isLoadingBillingInfo,
  clientSecret,
  paymentData,
  legalEntityName,
  licenseAmount,
  postalCode,
  setPostalCode,
  postalCodeError,
  packageType,
}) => {
  const appearance: any = {
    theme: 'none',
    variables: {
      spacingGridRow: '28px',
      spacingGridColumn: '28px',
      borderRadius: '8px',
      colorText: '#6F6E89',
      colorPrimary: '#5029Ef',
    },
    rules: {
      '.Input': {
        border: '2px solid #EAF0FE',
      },
      '.Input--invalid': {
        borderColor: '#f14949',
      },
      '.Input:focus-visible': {
        borderColor: '#5029ef',
      },
      '.Input:hover': {
        borderColor: '#5029ef',
      },
      '.Label': {
        marginLeft: '12px',
      },
      '.Error': {
        color: '#f14949',
        fontSize: '12px',
      },
    },
  }
  const options = {
    clientSecret,
    appearance,
  }

  return (
    <Stack
      alignItems="center"
      direction={{ xs: 'column', md: 'row' }}
      spacing="4.0rem"
      sx={{ marginTop: '5.6rem' }}
    >
      <Box width={{ md: '58.3rem' }} order={{ xs: 2, md: 0 }}>
        <Card>
          <CardContent
            sx={{
              padding: '4rem !important',
            }}
          >
            {!isLoading && (
              <Elements stripe={stripePromise} options={options}>
                <StripeForm
                  clientSecret={clientSecret}
                  handleNext={handleNext}
                  isLoadingBillingInfo={isLoadingBillingInfo}
                  postalCode={postalCode}
                  setPostalCode={setPostalCode}
                  postalCodeError={postalCodeError}
                  sx={{ '& .MuiButton-root': { alignSelf: 'center' } }}
                />
              </Elements>
            )}
          </CardContent>
        </Card>
      </Box>
      <Box padding="4.0rem" flex={1} width="100%">
        <Stack
          spacing="1.6rem"
          divider={<Divider orientation="horizontal" flexItem />}
        >
          {isLoadingBillingInfo ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <CircularProgress size="48px" />
            </Box>
          ) : (
            <>
              <Typography variant="bodyXLarge" sx={{ paddingBottom: '1.2rem' }}>
                Summary
              </Typography>
              <Stack direction="row" justifyContent="space-between">
                <Stack>
                  <Typography
                    variant="bodyMedium"
                    color="primary.600"
                    sx={{ paddingBottom: '1.2rem' }}
                  >
                    {`Elpha Secure ${packageType}`}
                  </Typography>
                  <Typography
                    variant="bodyMedium"
                    color="primary.400"
                    sx={{ paddingBottom: '1.2rem' }}
                  >
                    {`Yearly subscription (x${licenseAmount})`}
                  </Typography>
                </Stack>
                <Typography
                  variant="bodyMedium"
                  sx={{ paddingBottom: '1.2rem' }}
                >
                  {`$${paymentData?.gross_cost}`}
                </Typography>
              </Stack>
              <Stack spacing="1.6rem">
                <Stack direction="row" justifyContent="space-between">
                  <Typography
                    variant="bodyMedium"
                    color="primary.400"
                    sx={{ paddingBottom: '1.2rem' }}
                  >
                    Subtotal
                  </Typography>
                  <Typography
                    variant="bodyMedium"
                    sx={{ paddingBottom: '1.2rem' }}
                  >
                    {`$${paymentData?.gross_cost}`}
                  </Typography>
                </Stack>
                <Stack direction="row" justifyContent="space-between">
                  <Typography
                    variant="bodyMedium"
                    color="primary.400"
                    sx={{ paddingBottom: '1.2rem' }}
                  >
                    Fees
                  </Typography>
                  <Typography
                    variant="bodyMedium"
                    sx={{ paddingBottom: '1.2rem' }}
                  >
                    {`$${paymentData?.fees}`}
                  </Typography>
                </Stack>
                {paymentData?.taxes !== 0 && (
                  <Stack direction="row" justifyContent="space-between">
                    <Typography
                      variant="bodyMedium"
                      color="primary.400"
                      sx={{ paddingBottom: '1.2rem' }}
                    >
                      Sales tax
                    </Typography>
                    <Typography
                      variant="bodyMedium"
                      sx={{ paddingBottom: '1.2rem' }}
                    >
                      {`$${paymentData?.taxes}`}
                    </Typography>
                  </Stack>
                )}
              </Stack>
              <Stack direction="row" justifyContent="space-between">
                <Typography
                  variant="bodyMedium"
                  color="primary.400"
                  sx={{ paddingBottom: '1.2rem' }}
                >
                  Final total
                </Typography>
                {paymentData?.total_cost && (
                  <Typography
                    variant="bodyMedium"
                    sx={{ paddingBottom: '1.2rem' }}
                  >
                    {`$${paymentData?.total_cost.toFixed(2)}`}
                  </Typography>
                )}
              </Stack>
            </>
          )}
        </Stack>
      </Box>
    </Stack>
  )
}

export default Invoice
